(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solid8-product-reviews"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.s8-review-carousel').forEach(section=>{const move=direction=>{const list=section.querySelector('.jdgm-review-list');if(list)list.scrollBy({left:direction*(list.querySelector('.jm-review-item').getBoundingClientRect().width+20),behavior:'smooth'})};section.querySelector('[data-s8-review-prev]').addEventListener('click',()=>move(-1));section.querySelector('[data-s8-review-next]').addEventListener('click',()=>move(1));});
  } catch(e) { console.error(e); }
})();

})();
